import { LoadCounterOfferGroupData } from './load-counter-offer-group-data';
import { UserContactData } from './user-contact-data';

export interface GetLoadCounterOfferResponseData {
  allowNewCounterOffer: boolean;
  counterOffers: LoadCounterOfferGroupData[];
  shipperUserData: UserContactData;
}
